import { usePost } from '../../HttpClient';
import { brandBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateBrand() {
  const post = usePost(true, "tms");
  const createBrand = (request: any) =>
    post<{ brandId: string }>(`${brandBaseUrl}/brands`, request);

  return useMutationWithErrorHandling({
    mutationFn: async (request: any) => await createBrand(request),
  });
}